/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Special_Challenge_Banner_TitleInputs */

const en_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Special Event`)
};

const ar_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خاص`)
};

const de_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonderevent`)
};

const es_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento especial`)
};

const fr_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement spécial`)
};

const it_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento speciale`)
};

const ja_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペシャルイベント`)
};

const ko_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`특별 이벤트`)
};

const pt_br_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento especial`)
};

const ru_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Специальное событие`)
};

const th_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรมพิเศษ`)
};

const tr_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel Etkinlik`)
};

const zh_cn_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特别活动`)
};

const zh_tw_special_challenge_banner_title = /** @type {(inputs: Special_Challenge_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特別活動`)
};

/**
* | output |
* | --- |
* | "Special Event" |
*
* @param {Special_Challenge_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const special_challenge_banner_title = /** @type {((inputs?: Special_Challenge_Banner_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Special_Challenge_Banner_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_special_challenge_banner_title(inputs)
	if (locale === "ar") return ar_special_challenge_banner_title(inputs)
	if (locale === "de") return de_special_challenge_banner_title(inputs)
	if (locale === "es") return es_special_challenge_banner_title(inputs)
	if (locale === "fr") return fr_special_challenge_banner_title(inputs)
	if (locale === "it") return it_special_challenge_banner_title(inputs)
	if (locale === "ja") return ja_special_challenge_banner_title(inputs)
	if (locale === "ko") return ko_special_challenge_banner_title(inputs)
	if (locale === "pt_br") return pt_br_special_challenge_banner_title(inputs)
	if (locale === "ru") return ru_special_challenge_banner_title(inputs)
	if (locale === "th") return th_special_challenge_banner_title(inputs)
	if (locale === "tr") return tr_special_challenge_banner_title(inputs)
	if (locale === "zh_cn") return zh_cn_special_challenge_banner_title(inputs)
	return zh_tw_special_challenge_banner_title(inputs)
});